import { getAttribution, getQuoteSessionId, getDeviceId, isQuoteHistoOn } from './attribution';

// Enregistre / enrichit un lead de devis côté backend (fire-and-forget, ne bloque jamais l'UX).
// Relié par session_id : le backend fait un upsert par demande. device_id relie les demandes
// successives d'un même appareil (historisation, Lot 1). Appelé à l'estimation et à la saisie du téléphone.
export function logQuoteLead(payload) {
  try {
    const apiBase = process.env.REACT_APP_BUSINESS_API_ENDPOINT;
    if (!apiBase) return;
    const body = {
      session_id: getQuoteSessionId(),
      attribution: getAttribution(),
      ...(isQuoteHistoOn() ? { device_id: getDeviceId() } : {}),
      ...payload,
    };
    fetch(`${apiBase}/v1/public/quote/lead`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    // silencieux : la capture de lead ne doit jamais casser le parcours
  }
}
